import React, { useEffect, useState, useContext } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import SearchService from '../../../services/SearchService';
import LoadingContext from './loading-context';
import SearchDataContext from '../../../providers/searchData-context';
import { Form } from 'react-bootstrap';

interface format {
    name: string;
    value: string;
}
interface results {
    items: format[];
}

const FormatPicker: React.FC = () => {
    const { oktaAuth, authState } = useOktaAuth();
    const [formatList, setFormatList] = useState<results>();
    const loadingCtx = useContext(LoadingContext);
    const searchDataCtx = useContext(SearchDataContext);

    const uid: string = authState.accessToken.claims?.uid;
    //const userName: string = authState.accessToken.claims?.sub;
    const accessToken: string = authState.accessToken.accessToken;

    let triggers = [searchDataCtx.countyId, searchDataCtx.isReverse];

    if (searchDataCtx.isReverse) {
        triggers.push(searchDataCtx.searchBy);
    }

    useEffect(() => {
        if (!authState) return;

        setFormatList(undefined);

        if (
            (!searchDataCtx.isReverse &&
                (searchDataCtx.state === '' || searchDataCtx.countyId === '')) ||
            (searchDataCtx.isReverse &&
                (searchDataCtx.state === '' ||
                    searchDataCtx.countyId === '' ||
                    searchDataCtx.searchBy === ''))
        ) {
            return;
        }

        loadingCtx.setIsLoading(true, 'FormatPicker');

        SearchService.getFormat(searchDataCtx.countyId, searchDataCtx.searchBy, accessToken, uid)
            .then((response) => {
                const format = response as results;
                setFormatList(format);

                loadingCtx.setIsLoading(false, 'FormatPicker');
            })
            .catch((ex) => {
                //setError(ex.response.data);
                //setIsError(true);
                loadingCtx.setIsLoading(false, 'FormatPicker');
            });
    }, triggers);

    if (!authState) {
        return <div></div>;
    }

    const onChange = (e: any) => {
        const selectedIndex = e.target.selectedIndex;
        const format = e.target.value;
        const formatDescription = e.target[selectedIndex].text;
        searchDataCtx.setFormat(format, formatDescription);
    };

    return (
        <>
            <label>Format</label>
            <div className='col'>
                <Form.Control
                    tabIndex={3}
                    id='search-format'
                    as='select'
                    className='form-select form-select-sm '
                    required
                    onChange={onChange}
                    value={searchDataCtx.format}
                    name='format'
                >
                    <option value=''>Choose...</option>
                    {/* {formatList && formatList.items.length > 1 && (
                        <option value='all'>All</option>
                    )} */}
                    {formatList &&
                        formatList.items.map((data) => (
                            <option key={data.value} value={data.value}>
                                {data.name}
                            </option>
                        ))}
                </Form.Control>
                <Form.Control.Feedback type='invalid'>
                    Please choose your Format
                </Form.Control.Feedback>
            </div>
        </>
    );
};

export default FormatPicker;
